import { Component, OnInit, OnDestroy, Input, ViewChild, ElementRef, AfterViewInit, ChangeDetectorRef, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

import { ByocEpisodeFetchService } from '../../service/fetch.service';
import { Subscription, tap } from 'rxjs';
import { array, control } from '../../../../../utils';

@Component({
    selector: 'app-byoc-episode-step-fetch-questions-edit',
    templateUrl: './edit.component.html',
    styleUrls: ['./edit.component.scss'],
    standalone: false
})
export class ByocEpisodeStepGeneralQuestionsEditComponent implements OnInit, OnDestroy, AfterViewInit {
    private readonly formBuilder = inject(UntypedFormBuilder);
    private readonly changeDetectorRef = inject(ChangeDetectorRef);
    private readonly byocEpisodeFetchService = inject(ByocEpisodeFetchService);
    @ViewChild('box', { static: true })
    box!: ElementRef;

    @Input()
    formQuestion!: UntypedFormGroup;

    @Input()
    index!: number;

    form!: UntypedFormGroup;

    readonly control = control;

    private subscriptions: Subscription = new Subscription();

    get answersLimitReached(): boolean {
        return this.answers.length > 9;
    }

    get answers() {
        return array(this.form.get('answers')).controls;
    }

    ngOnInit() {
        this.initForm();
        this.changeDetectorRef.detectChanges();
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.byocEpisodeFetchService.updatePsScrollTo(this.box.nativeElement.getBoundingClientRect().top);
        }, 10);
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    cancelClick(): void {
        this.byocEpisodeFetchService.close();
    }

    saveClick(): void {
        if (this.form.invalid) {
            return;
        }
        this.formQuestion.patchValue({ title: this.form.value.title });
        this.formQuestion.setControl('answers', this.form.get('answers'));
        this.byocEpisodeFetchService.close();
    }

    /**
     * Add Wrong Answer
     */
    addWrongAnswerClick(): void {
        this.addAnswer(false);
        this.byocEpisodeFetchService.updatePs();
    }

    /**
     * Removes Answer
     * @param i index of removed element
     */
    removeAnswerClick(i: number) {
        array(this.form.get('answers')).removeAt(i);
        this.byocEpisodeFetchService.updatePs();
    }

    /**
     * Init Form
     */
    private initForm(): void {
        this.form = this.formBuilder.group({
            title: [this.formQuestion.value.title, [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
            answers: this.formBuilder.array([]),
        });

        this.formQuestion.value.answers.forEach((answer: { correct: boolean; title: string }) => {
            this.addAnswer(answer.correct, answer.title);
        });

        this.subscriptions.add(
            this.form.valueChanges
                .pipe(
                    tap(() => {
                        this.patchForm();
                    }),
                )
                .subscribe(),
        );
    }

    /**
     * Add Wrong Answer
     * @param correct flag if added answer is the correct one
     */
    private addAnswer(correct: boolean, title?: string) {
        array(this.form.get('answers')).push(
            new UntypedFormGroup({
                title: new UntypedFormControl(title ? title : '', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]),
                correct: new UntypedFormControl(correct, [Validators.required]),
            }),
        );
        this.changeDetectorRef.detectChanges();
        setTimeout(() => {
            this.byocEpisodeFetchService.updatePsScrollTo(this.box.nativeElement.getBoundingClientRect().top);
        }, 10);
    }

    /**
     * Patches Form
     */
    private patchForm(): void {
        this.form.patchValue(
            {
                title: this.form.value.title.split('<').join('').split('>').join(''),
                answers: this.form.value.answers.map((answer: any) => {
                    answer.title = answer.title.split('<').join('').split('>').join('');
                    return answer;
                }),
            },
            { emitEvent: false },
        );
    }
}
